import { format } from "date-fns";

import { Value } from "react-calendar/dist/cjs/shared/types";
import { DATE_TIME_FORMAT } from "constants/index";

const getDatePayload = (
  date: Date | Value | null | undefined,
  isEndDate = false
) => {
  if (!date || Array.isArray(date)) return "";
  const parsed = new Date(date);
  if (isEndDate) {
    parsed.setHours(23, 59, 59, 0);
  } else {
    parsed.setHours(0, 0, 0, 0);
  }
  return format(parsed, DATE_TIME_FORMAT);
};

export default getDatePayload;
